// Circle-settings function handles (bead hf-e3b-circle-people-r3z.2).
//
// Same shape as ./plan.ts and ./calendarFeed.ts: named handles re-exporting the
// generated api, plus result types inferred with `FunctionReturnType` so the browser
// cannot drift from the backend. The feature module imports only the TYPES.

import type { FunctionReturnType } from "convex/server";

import { api } from "../../../../convex/_generated/api";

/**
 * The whole settings shape, for anybody who can see the plan.
 *
 * `plan.view`, not `plan.manage` — block boundaries are not secret, and the result
 * carries `canManageSettings` so the surface renders what the SERVER says this member
 * may do rather than guessing from a role (AUT-007).
 */
export const circleSettingsQuery = api.domain.circleSettings.read;

export const setBlockDefinitionsMutation = api.domain.circleSettings.setBlockDefinitions;
export const setDirectRequestExpiryPolicyMutation =
  api.domain.circleSettings.setDirectRequestExpiryPolicy;
export const setTimeZoneMutation = api.domain.circleSettings.setTimeZone;
export const setDisplayNameMutation = api.domain.circleSettings.setDisplayName;
export const setSupportedPersonNameMutation = api.domain.circleSettings.setSupportedPersonName;
export const setSupportedPersonPrintContactMutation =
  api.domain.circleSettings.setSupportedPersonPrintContact;
export const setSupportedPersonPrintContactNameMutation =
  api.domain.circleSettings.setSupportedPersonPrintContactName;

export type CircleSettingsResult = FunctionReturnType<typeof circleSettingsQuery>;
export type SetBlockDefinitionsResult = FunctionReturnType<typeof setBlockDefinitionsMutation>;
export type SetDirectRequestExpiryPolicyResult = FunctionReturnType<
  typeof setDirectRequestExpiryPolicyMutation
>;
export type SetTimeZoneResult = FunctionReturnType<typeof setTimeZoneMutation>;
export type SetDisplayNameResult = FunctionReturnType<typeof setDisplayNameMutation>;
export type SetSupportedPersonNameResult = FunctionReturnType<
  typeof setSupportedPersonNameMutation
>;
export type SetPrintContactResult = FunctionReturnType<
  typeof setSupportedPersonPrintContactMutation
>;
export type SetPrintContactNameResult = FunctionReturnType<
  typeof setSupportedPersonPrintContactNameMutation
>;
